import React from "react";
import logo from "../images/icon.png";
import { useRecoilValue } from "recoil";
import { langState } from "./recoilAtom";

const Logo = () => {
  const lang = useRecoilValue(langState);

  return (
    <h2 className="logo">
      <img src={logo} alt="SDS Optic logo" />
      <div className="logo-text-wrapper">
        <span className="logo-top-text">SDS Optic</span>
        <span className="logo-bottom-text">Lifesaving innovations</span>
      </div>
    </h2>
  );
};

export default Logo;
